import { TableCells, BankAccountView } from 'models';
import { formatNum } from 'utils';

export const bankAccountsTableCells: TableCells<BankAccountView>[] = [
  {
    id: 'Number',
    type: 'string',
    label: '##attribute#uds_bankaccount#uds_name',
    defaultLabelRegister: true,
    small: true,
    xs: true,
  },
  {
    id: 'Operator.Name',
    type: 'string',
    label: '##attribute#uds_bankaccount#uds_operatorid',
    defaultLabelRegister: true,
    small: true,
  },
  {
    id: 'Balance.Value',
    type: 'number',
    label: '##attribute#uds_bankaccount#uds_balance',
    render: (bankAccount) =>
      `${formatNum(bankAccount.Balance?.Value)} ${
        bankAccount.Balance?.Symbol || '€'
      }`,
    small: true,
    xs: true,
    xsStyles: { width: '30%' },
  },
  {
    id: 'BalanceDate',
    type: 'date',
    label: '##attribute#uds_bankaccount#uds_balancedate',
    small: true,
  },
];
